module.exports = __webpack_public_path__ + "img/Canberra_National_Carillon_Australia.96a55f28.jpg";